export const GET_SHORTS = "GET_SHORTS";
export const IMPORT_SHORT = "IMPORT_SHORT";
export const EDIT_SHORT = "EDIT_SHORT";
export const DELETE_SHORT = "DELETE_SHORT";
export const LOADING = "LOADING";
export const HASHTAG = "HASHTAG";
export const HOMEHASHTAG = "HOMEHASHTAG";
export const DELETEHASHTAG = "DELETEHASHTAG";
export const GETFEATURETAGS = "GETFEATURETAGS";
export const UPDATEFEATURE = "UPDATEFEATURE";
export const FILTERDATA = "FILTERDATA";
